import { render, staticRenderFns } from "./showActBox.vue?vue&type=template&id=6e51026d&scoped=true"
import script from "./showActBox.vue?vue&type=script&lang=js"
export * from "./showActBox.vue?vue&type=script&lang=js"
import style0 from "./showActBox.vue?vue&type=style&index=0&id=6e51026d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e51026d",
  null
  
)

export default component.exports